import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';

const LoadError = ({ message = 'Failed to load data', onRetry }) => (
  <section role="alert" className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
    <FiAlertCircle className="mx-auto text-red-500" size={30} />
    <p className="mt-2 text-sm font-medium text-red-800">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="mt-4 inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-red-700"
      >
        <FiRefreshCw size={15} /> Retry
      </button>
    )}
  </section>
);

export default LoadError;
